<template>
  <jt-card-default
    :shouldShowSelectDay="true"
    :cardSelectType="0"
    :shouldShowFullscreen="false"
    @change="onChangeSelectDate"
  >
    <div v-if="isLoading" class="div-loader">
      <div class="spinning-loader rotate"></div>
    </div>

    <br />
    <br />

    <q-markup-table separator="none" class="bg-blue-grey-2">
      <thead>
        <tr>
          <th colspan="3">
            <div class="text-h6">{{this.$gettext('DASHBOARD_OPERATION')}}</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th colspan="3">
            <hr />
          </th>
        </tr>
        <tr>
          <td colspan="3">

              <q-select color="teal"  bg-color="white" outlined
                v-model="model"
                use-input
                hide-selected
                label="Resíduo"
                fill-input
                input-debounce="0"
                :options="options"
                @filter="filterFn"
                style="padding-bottom: 32px"
                behavior="dialog"
                @input="showValues"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      {{this.$gettext('DASHBOARD_NO_RESULTS')}}
                    </q-item-section>
                  </q-item>
                </template>

              </q-select>
          </td>
        </tr>
        <tr>
          <th class="text-left"></th>
          <th class="text-center">{{this.$gettext('DASHBOARD_OPERATION_DAY')}}</th>
          <th class="text-center">{{this.$gettext('DASHBOARD_OPERATION_AMOUNT')}}</th>
        </tr>
        <tr v-for="item in rowsMonthYear" :key="item">
          <td class="text-right">{{ item.name }}</td>
          <td class="text-center">
            <q-chip
              square
              size="md"
              color="white"
              class="text-center full-width"
            >
              <div class="text-center full-width">{{ item.day }}</div>
            </q-chip>
          </td>
          <td class="text-center">
            <q-chip
              square
              size="md"
              color="white"
              class="text-center full-width"
              ><div class="text-center full-width">
                {{ item.month }}
              </div></q-chip
            >
          </td>
        </tr>
      </tbody>
    </q-markup-table>
  </jt-card-default>
</template>
<script>
import JtCardDefault from 'src/components/dashboard/dashboard-card-components/base/JtCardDefault.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import JtInfoCard from 'src/components/dashboard/dashboard-card-components/JtInfoCard.vue'

@Component({
  name: 'Operation',
  components: {
    JtCardDefault, JtInfoCard
  }
})
export default class Operation extends Vue {
  isLoading = false;

  currentDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  };

  rowsMonthYear = [];

  residuePrice;
  stringOptions;
  model = null;
  options;

  setZeros () {
    this.rowsMonthYear = [
      {
        name: 'Tonelada',
        day: 0,
        month: 0
      },
      {
        name: 'Unidade',
        day: 0,
        month: 0
      }
    ]
  }

  async created () {
    this.onChangeSelectDate(this.currentDate)
    this.stringOptions = await this.getResiduePrice()
    this.options = this.stringOptions
  }

  filterFn (val, update, abort) {
    update(() => {
      const needle = val.toLowerCase()
      this.options = this.stringOptions.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
      this.model = needle
    })
  }

  async getResiduePrice () {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'operation'
      }
    )

    const options = registros.map((registro) => {
      return {
        label: registro.name,
        id: registro.id
      }
    })

    return options
  }

  onChangeSelectDate (date) {
    this.isLoading = true
    this.currentDate = date
    this.model = null
    this.setDataTable(date)

    setTimeout(() => {
      this.isLoading = false
    }, 500)
  }

  setDataTable (date) {
    this.setZeros()
  }

  async setOperationReceiptDay (date, idResidue) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'operationReceiptDay',
        day: date.day,
        month: date.month,
        year: date.year,
        idResidue: idResidue
      }
    )

    if (registros.length != 0) {
      Object.keys(registros).forEach(function (key, index) {
        registros[key].tonne =
          parseFloat(registros[key].tonne.replaceAll('.', '')) / 1000
      })

      const data = registros.reduce((register) => register)

      this.rowsMonthYear[0].day = parseInt(data.tonne).toLocaleString('pt-BR')
      this.rowsMonthYear[1].day = data.vehicle.toLocaleString('pt-BR')
    } else {
      this.rowsMonthYear[0].day = 0
      this.rowsMonthYear[1].day = 0
    }
  }

  async setOperationReceiptMonth (date, idResidue) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'operationReceiptMonth',
        month: date.month,
        year: date.year,
        idResidue: idResidue
      }
    )

    if (registros.length != 0) {
      Object.keys(registros).forEach(function (key, index) {
        registros[key].tonne =
          parseFloat(registros[key].tonne.replaceAll('.', '')) / 1000
      })

      const data = registros.reduce((register) => register)

      this.rowsMonthYear[0].month = parseInt(data.tonne).toLocaleString('pt-BR')
      this.rowsMonthYear[1].month = data.vehicle.toLocaleString('pt-BR')
    } else {
      this.rowsMonthYear[0].month = 0
      this.rowsMonthYear[1].month = 0
    }
  }

  async showValues (value) {
    const idResidue = value.id
    await this.setOperationReceiptDay(this.currentDate, idResidue)
    await this.setOperationReceiptMonth(this.currentDate, idResidue)
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

.q-chip {
  max-width: 180px;
}
</style>
